import { SignIn } from '@clerk/clerk-react';
import { Helmet } from 'react-helmet-async';

/**
 * Clerk-hosted sign-in flow. The recovery path — used by returning users
 * on a new device, or anyone who has signed out.
 *
 * After successful sign-in, Clerk redirects to /onboarding/complete via
 * fallbackRedirectUrl. That page idempotently reconciles with the API
 * (returning the existing user row via GET /v1/users/me when localStorage
 * is empty) and hydrates localStorage before forwarding to /me.
 */
export default function SignInPage() {
  return (
    <>
      <Helmet>
        <title>Sign in · TownInsider</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <main
        id="main-content"
        className="container-narrow safe-top safe-bottom flex min-h-dvh items-center justify-center px-4 py-8"
      >
        <SignIn
          path="/sign-in"
          routing="path"
          signUpUrl="/sign-up"
          fallbackRedirectUrl="/onboarding/complete"
        />
      </main>
    </>
  );
}
